import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/images/Tours/load-external-translation.png'
import _imports_1 from '@/images/Tours/use-external-translation.png'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tour_step = _resolveComponent("el-tour-step")!
  const _component_el_tour = _resolveComponent("el-tour")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      type: "primary",
      onClick: _ctx.startStuleTour,
      disabled: !_ctx.tourAvailable
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('externalTranslationTour.tourName')), 1)
      ]),
      _: 1
    }, 8, ["onClick", "disabled"]),
    _createVNode(_component_el_tour, {
      modelValue: _ctx.tourStart,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tourStart) = $event)),
      "target-area-clickable": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tour_step, {
          target: _ctx.enableExternalTranslationsTarget,
          title: _ctx.$t('externalTranslationTour.enableExternalTranslations')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('externalTranslationTour.enableExternalTranslationsDescription')), 1)
          ]),
          _: 1
        }, 8, ["target", "title"]),
        _createVNode(_component_el_tour_step, {
          target: _ctx.selectTranslationProviderTarget,
          title: _ctx.$t('externalTranslationTour.selectTranslationProvider')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('externalTranslationTour.selectTranslationProviderDescription')), 1)
          ]),
          _: 1
        }, 8, ["target", "title"]),
        _createVNode(_component_el_tour_step, {
          target: _ctx.variantsButtonTarget,
          title: _ctx.$t('externalTranslationTour.variantsButton')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('externalTranslationTour.variantsButtonDescription')), 1)
          ]),
          _: 1
        }, 8, ["target", "title"]),
        _createVNode(_component_el_tour_step, {
          target: _ctx.variantsButtonTarget,
          title: _ctx.$t('externalTranslationTour.loadExternalTranslations'),
          "content-style": _ctx.loadExternalTranslationsStyle,
          placement: "left"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('externalTranslationTour.loadExternalTranslationsDescription')), 1),
            _cache[1] || (_cache[1] = _createElementVNode("img", {
              class: "screenshot",
              src: _imports_0,
              alt: "tour.png"
            }, null, -1))
          ]),
          _: 1
        }, 8, ["target", "title", "content-style"]),
        _createVNode(_component_el_tour_step, {
          target: _ctx.variantsButtonTarget,
          title: _ctx.$t('externalTranslationTour.selectExternalTranslation'),
          "content-style": _ctx.selectExternalTranslationStyle,
          placement: "left"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('externalTranslationTour.selectExternalTranslationDescription')), 1),
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              class: "screenshot",
              src: _imports_1,
              alt: "tour.png"
            }, null, -1))
          ]),
          _: 1
        }, 8, ["target", "title", "content-style"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}